module.exports = __webpack_public_path__ + "img/liuzhou.b580745e.jpg";